module.exports = __webpack_public_path__ + "static/media/2040319000.21cbed57.jpg";